import { render, staticRenderFns } from "./BankIcon.vue?vue&type=template&id=43b05c6d&"
import script from "./BankIcon.vue?vue&type=script&lang=js&"
export * from "./BankIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports